import { HttpErrorResponse } from '@angular/common/http';

export type DeletionBlockerCode = 'EVENT_ACTIVE';

export interface DeletionBlocker {
  code: DeletionBlockerCode;
  tenantId: string;
  eventId: string | null;
  label: string;
}

interface BlockedResponseBody {
  data?: { blockers?: unknown };
}

function isDeletionBlocker(candidate: unknown): candidate is DeletionBlocker {
  if (!candidate || typeof candidate !== 'object') {
    return false;
  }
  const blocker = candidate as Partial<DeletionBlocker>;

  return (
    typeof blocker.code === 'string' &&
    typeof blocker.tenantId === 'string' &&
    typeof blocker.label === 'string'
  );
}

export function extractDeletionBlockers(
  error: HttpErrorResponse,
): DeletionBlocker[] {
  const body = error.error as BlockedResponseBody | null;
  const blockers = body?.data?.blockers;

  if (!Array.isArray(blockers)) {
    return [];
  }

  return blockers.filter(isDeletionBlocker);
}

export function carriesDeletionBlockers(error: HttpErrorResponse): boolean {
  return extractDeletionBlockers(error).length > 0;
}
